import { trackMixpanel } from '@monorepo/client-common';
import { EventTypes } from '@monorepo/types';
import { useStore } from '@hub/helpers/use-store';
import { EnvService } from '@hub/services/core/env-service';

export type LiveChatFlow =
  | 'failed-sending-mail'
  | 'withdraw'
  | 'welcome'
  | 'otp'
  | 'mail-confirmation'
  | 'not-received-mail'
  | 'affiliate'
  | 'no-more-retries'
  | 'mail-rejected'
  | 'payout-form';

export const useOpenLiveChat = ({ flow }: { flow: LiveChatFlow }) => {
  const {
    dataStore: { userStore },
  } = useStore();

  const handleOpenLiveChat = () => {
    if (!window.LiveChatWidget) return;

    window.LiveChatWidget.call('maximize');

    trackMixpanel({
      event: EventTypes.OPEN_LIVE_CHAT,
      properties: {
        email: userStore.currentUser.email,
        country: userStore.currentUser.country,
        platform: EnvService.get().application,
        flow,
      },
    });
  };

  return handleOpenLiveChat;
};
